module.exports = __webpack_public_path__ + "img/org_icon.815d9388.svg";